module.exports = __webpack_public_path__ + "static/media/magnusson_ost.c3251161.svg";